import $ from 'jquery';

const $slider = $('.brand-block__slider');

$slider.slick({
	dots: false,
	infinite: true,
	slidesToShow: 5,
	centerMode: false,
	speed: 300,
	autoplay: true,
	autoplaySpeed: 3000,
	arrows: false,
	responsive: [{
		breakpoint: 600,
		settings: {
			slidesToShow: 1,
			infinite: true,
			autoplaySpeed: 2000,
		}
	}]
});

